/* eslint-disable no-unused-vars */
// linter gives a false-positive for typescript-enums, needs to investigate
export enum LibraryContentCardTypeEnum {
  EDITOR = 'journey-editor',
  DASHBOARD = 'dashboard',
  LIBRARY = 'library',
  SYNCED_STEP = 'synced-step',
}
